export const languages = [
  { label: "English", code: "en" },
  { label: "हिंदी", code: "hi" },
  { label: "ગુજરાતી", code: "gu" },
  { label: "বাংলা", code: "bn" },
  { label: "मराठी", code: "mr" },
  { label: "తెలుగు", code: "te" },
  { label: "தமிழ்", code: "ta" },
  { label: "ಕನ್ನಡ", code: "kn" },
  { label: "ଓଡ଼ିଆ", code: "or" },
  { label: "മലയാളം", code: "ml" },
  { label: "ਪੰਜਾਬੀ", code: "pa" },
  { label: "অসমীয়া", code: "as" },
];
export  const languageCodes = {
    en: "english",
    hi: "hindi",
    gu: "gujarati",
    bn: "bengali",
    mr: "marathi",
    te: "telugu",
    ta: "tamil",
    kn: "kannada",
    or: "odia",
    ml: "malayalam",
    pa: "punjabi",
    as: "assamese",
  };

//   '| Language      | Code | Font Link '                                                                                                                                                                    
// "| **Hindi**     | `hi` | [NotoSansDevanagari-Regular.ttf](https://github.com/googlefonts/noto-fonts/blob/main/hinted/ttf/NotoSansDevanagari/NotoSansDevanagari-Regular.ttf?raw=true)
// "| **Gujarati**  | `gu` | [NotoSansGujarati-Regular.ttf](https://github.com/googlefonts/noto-fonts/blob/main/hinted/ttf/NotoSansGujarati/NotoSansGujarati-Regular.ttf?raw=true)                         
// "| **Bengali**   | `bn` | [NotoSansBengali-Regular.ttf](https://github.com/googlefonts/noto-fonts/blob/main/hinted/ttf/NotoSansBengali/NotoSansBengali-Regular.ttf?raw=true)                            
// "| **Marathi**   | `mr` | [NotoSansDevanagari-Regular.ttf](https://github.com/googlefonts/noto-fonts/blob/main/hinted/ttf/NotoSansDevanagari/NotoSansDevanagari-Regular.ttf?raw=true) *(same as Hindi)* |
// "| **Telugu**    | `te` | [NotoSansTelugu-Regular.ttf](https://github.com/googlefonts/noto-fonts/blob/main/hinted/ttf/NotoSansTelugu/NotoSansTelugu-Regular.ttf?raw=true)                               |
// "| **Tamil**     | `ta` | [NotoSansTamil-Regular.ttf](https://github.com/googlefonts/noto-fonts/blob/main/hinted/ttf/NotoSansTamil/NotoSansTamil-Regular.ttf?raw=true)                                  |
// "| **Kannada**   | `kn` | [NotoSansKannada-Regular.ttf](https://github.com/googlefonts/noto-fonts/blob/main/hinted/ttf/NotoSansKannada/NotoSansKannada-Regular.ttf?raw=true)                            |
// "| **Malayalam** | `ml` | [NotoSansMalayalam-Regular.ttf](https://github.com/googlefonts/noto-fonts/blob/main/hinted/ttf/NotoSansMalayalam/NotoSansMalayalam-Regular.ttf?raw=true)                      |
// | **Punjabi**   | `pa` | [NotoSansGurmukhi-Regular.ttf](https://github.com/googlefonts/noto-fonts/blob/main/hinted/ttf/NotoSansGurmukhi/NotoSansGurmukhi-Regular.ttf?raw=true)                         |
// | **Assamese**  | `as` | [NotoSansBengali-Regular.ttf](https://github.com/googlefonts/noto-fonts/blob/main/hinted/ttf/NotoSansBengali/NotoSansBengali-Regular.ttf?raw=true) *(same as Bengali)*        |
